<template>
  <div id="app">
    <span class="basisInformation">观课统计</span>
    <el-divider></el-divider>
    <!-- 头部功能区域 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item v-if="schoolName === '米学'">
        <el-select
          placeholder="请选择学校"
          v-model="viewHistoryObj.schoolName"
          filterable
        >
          <el-option
            v-for="item in schoolList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          style="width: 140px"
          placeholder="请输入教师姓名"
          v-model.trim="viewHistoryObj.teacherName"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          placeholder="请输入教师手机号"
          v-model.trim="viewHistoryObj.mobile"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          style="width: 180px"
          size="small"
          v-model="viewHistoryObj.watchMonth"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择观看月份"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchLists">搜 索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="callExportCourseViewHistoryList"
        >导出
        </el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      style="width: 100%"
      border
      stripe
      ref="noteTable"
      :data="viewHistoryTableList"
    >
      <el-table-column align="center" prop="schoolName" label="学校名称">
      </el-table-column>
      <el-table-column align="center" prop="teacherName" label="教师名称">
      </el-table-column>
      <el-table-column align="center" prop="mobile" label="教师手机号">
      </el-table-column>
      <el-table-column align="center" prop="courseName" label="课程名称" width="300px">
      </el-table-column>
      <el-table-column align="center" prop="gradeName" label="年级" width="80px">
      </el-table-column>
      <el-table-column align="center" prop="viewersDuration" label="观看时长(分钟)" width="120px">
      </el-table-column>
      <el-table-column align="center" prop="intoTime" label="进入时间" width="150px">
      </el-table-column>
      <el-table-column align="center" prop="quitTime" label="退出时间" width="150px">
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="viewHistoryObj.totalCount"
    ></el-pagination>
  </div>
</template>
<script>
import datajson from './components/nation.json'

import {deletdStudent, exportCourseViewHistoryList, fileSever, getSchoolList, resetPassword, getCourseViewHistoryList,} from '@/api/home'

export default {
  data() {
    return {
      // 顶部搜索区域
      viewHistoryObj: {
        curPage: 1,
        pageSize: 10,
        schoolName: '',
        teacherName: '',
        mobile: '',
        watchMonth: '',
        totalCount: 0, //  viewHistoryTableList 总条数
      },
      token: '',
      schoolName: '',
      viewHistoryTableList: [], // 表格数据列表
      multipleSelection: [], //选中学生列表
      dialogVisible: false, //导出学生 开关
      dialogAction: '',
      schoolList: [], // 学校列表
      classesList: [], // 班级列表
      // 导出学生
      classesLists: [], // 班级列表
      nationList: datajson.nationList, // 民族列表
      relationList: datajson.relationList, // 关系列表
      checkList: [], //选择框
      objClassesId: [],
      className: [], //班级名称
      classNames: '', //年级名称
      type: '',
      typeTime: '',
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.schoolName = localStorage.getItem('schoolName')
    this.initSchoolList()
    this.searchViewHistory()
    this.fileSever()
    this.type = localStorage.getItem('type')
  },
  methods: {
    // 获取服务器地址
    async fileSever() {
      const {data: res} = await fileSever({
        schoolId: this.schoolId,
      })
    },

    // 获取观看历史列表
    searchViewHistory() {
      getCourseViewHistoryList(this.viewHistoryObj).then((res) => {
        this.viewHistoryTableList = res.data.data.dataList
        this.viewHistoryObj.totalCount = res.data.data.totalCount
      })
    },

    // 分页页码变化
    currentChange(e) {
      this.viewHistoryObj.curPage = e
      // 调用查询学生列表
      this.searchViewHistory()
    },

    // 获取年级列表
    initSchoolList() {
      getSchoolList({
        pageSize: 2147483647,
      }).then((res) => {
        this.schoolList = res.data.data.dataList
      })
    },
    // 导出学生
    changeclassesList(value) {
      this.viewHistoryObj.classesId = ''
      this.classesLists = []
      this.schoolList.map((item) => {
        if (item.gradeId == value) {
          this.classNames = item.name
          this.classesLists = item.classesList
        }
      })
      // this.classesList = value.classesList;
      this.checkList = []
    },
    // 搜索和重置功能
    searchList() {
      // this.viewHistoryObj.curPage = 1
      this.searchViewHistory()
    },
    searchLists() {
      this.viewHistoryObj.curPage = 1
      this.searchViewHistory()
    },

    // 删除学生
    DeleteStudentHandle(obj) {
      this.$confirm(
        `该操作将永久性删除 <span style="color:#409EFF;margin:0 10px;">${obj.student.name}</span>学生的数据！`,
        // `您确定要删除 <span style="color:#409EFF;margin:0 10px;">${obj.student.name}</span>学生么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          deletdStudent(obj.student.id).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功',
              })
              this.searchViewHistory()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    //重置密码
    ApiResetPass(roleType, obj) {
      console.log(obj)
      this.$confirm(
        `您确定要重置<span style="color:#409EFF;margin:0 10px;">${
          obj.student.name + ' '
        }${
          roleType == 'parent' ? '家长' : '学生'
        }</span>的密码么?重置后的密码是000000`,
        '重置密码',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let data = {
            roleType,
            userId:
              roleType == 'parent' ? obj.parentList[0].id : obj.student.id,
          }
          resetPassword({...data}).then(() => {
            this.$message({
              type: 'success',
              message: '重置成功',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置',
          })
        })
    },
    // 导出
    async callExportCourseViewHistoryList() {
      const res = await exportCourseViewHistoryList(this.viewHistoryObj, '观看统计导出')
    },
  },
}
</script>
<style scoped>
.basisInformation {
  font-size: 16px;
  font-weight: 700;
}

.el-divider {
  margin-top: 18px;
  margin-bottom: 18px;
}

.el-checkbox-group {
  margin-left: 50px;
}

.el-table__body .el-button + .el-button {
  margin-left: 20px;
}

.left_btn {
  margin-left: 12px;
}

.text_btn {
  margin-left: 30px;
}

/* .el-form{
  margin-bottom: 8px;
} */
</style>



// WEBPACK FOOTER //
// src/views/school/components/CourseViewHistory.vue